<template>
  <KTCard :title="title" :subtitle="subTitle">
    <template v-slot:body>
      <!-- fuente alta form -->
      <b-form class="form" @submit.prevent="onSubmit">
        <!-- codigo -->
        <b-form-group
          label="FJ *"
          label-for="codigo"
          description="Escriba la FJ"
        >
          <b-form-input
            id="codigo"
            v-model="formaJuridica.codigo"
            type="text"
            required
            placeholder="FJ"
          ></b-form-input>
        </b-form-group>
        <!-- sex -->
        <b-form-group
          label="Sexo *"
          label-for="sex"
          description="Escriba el sexo"
        >
          <b-form-input
            id="sex"
            v-model="formaJuridica.sex"
            type="text"
            required
            placeholder="Sexo"
          ></b-form-input>
        </b-form-group>
        <!-- letterCIF -->
        <b-form-group
          label="Letra CIF *"
          label-for="letterCIF"
          description="Escriba la letra CIF"
        >
          <b-form-input
            id="letterCIF"
            v-model="formaJuridica.letterCIF"
            type="text"
            required
            placeholder="Letra CIF"
          ></b-form-input>
        </b-form-group>
        <!-- literal -->
        <b-form-group
          label="Literal Forma Jurídica *"
          label-for="literal"
          description="Escriba el literal"
        >
          <b-form-input
            id="literal"
            v-model="formaJuridica.literal"
            type="text"
            required
            placeholder="Literal Forma Jurídica"
          ></b-form-input>
        </b-form-group>
        <div class="d-flex justify-content-end span-3">
          <b-button class="mr-2" @click="cancel()">Cancelar</b-button>
          <b-button type="submit" variant="primary">Guardar</b-button>
        </div>
      </b-form>
    </template>
  </KTCard>
</template>

<script>
import KTCard from "@/view/content/Card.vue";
import {
  ADD_FORMA_JURIDICA,
  EDIT_FORMA_JURIDICA
} from "@/core/services/store/formaJuridica.module";

export default {
  name: "forma-juridica-add",
  components: {
    KTCard
  },
  data() {
    return {
      formaJuridica: {
        id: null,
        codigo: "",
        literal: ""
      }
    };
  },
  computed: {
    title() {
      return this.isEdit ? "Editar forma jurídica" : "Nueva forma jurídica";
    },
    subTitle() {
      return this.isEdit ? "Modifique los datos" : "Escriba todos los datos";
    },
    isEdit() {
      return this.$route.params.id !== undefined;
    }
  },
  mounted() {
    if (this.isEdit) {
      this.formaJuridica = this.$store.getters.formaJuridica(
        this.$route.params.id
      );
    }
  },
  methods: {
    cancel() {
      this.$router.push("/lists/formas-juridicas");
    },
    onSubmit() {
      if (this.isEdit) {
        this.$store.commit(EDIT_FORMA_JURIDICA, this.formaJuridica);
      } else {
        this.$store.commit(ADD_FORMA_JURIDICA, this.formaJuridica);
      }
      this.cancel();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/pages/users/add";
</style>
